import CustomButton from 'Components/CustomButton'
import { FaultReport } from 'Services/SalesManagement/Features/FaultReport/Components/FaultReport'
import type {
  FaultReportShape,
  FaultReportType
} from 'Services/SalesManagement/Features/FaultReport/faultReportSlice'
import HomeCard from 'Services/SalesManagement/Features/Home/Components/HomeCard'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import AddIcon from '@mui/icons-material/Add'
import { Box, CardActions, CardContent, CardHeader } from '@mui/material'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

const FaultReportList: FC<{
  faultReports: FaultReportShape[]
  isSuperuser: boolean
  faultReportType: FaultReportType
  title: string
  noEntriesText: string
}> = ({ faultReports, isSuperuser, faultReportType, title, noEntriesText }) => {
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/fault-reports`
  const navigate = useNavigate()

  const handleEdit = (faultReportId: number) => {
    navigate(`${baseUrl}/${faultReportId}/`, {
      state: { faultReportType }
    })
  }

  const handleCreateClick = () => {
    navigate(`${baseUrl}/create/`, {
      state: { faultReportType }
    })
  }

  return (
    <HomeCard>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
        <CardHeader title={title} />
        <CardContent>
          {faultReports.length > 0 ? (
            <>
              {faultReports.map(faultReport => (
                <FaultReport
                  key={faultReport.id}
                  faultReport={faultReport}
                  handleEditClick={() => handleEdit(faultReport.id)}
                  canControl={isSuperuser}
                />
              ))}
            </>
          ) : (
            <Box mb={2}>
              <Typography color="text.secondary">{noEntriesText}</Typography>
            </Box>
          )}
        </CardContent>
      </Box>
      <CardActions>
        {isSuperuser && (
          <CustomButton
            sx={{ mb: 1 }}
            onClick={handleCreateClick}
            size="small"
            startIcon={<AddIcon />}
          >
            {t`Create new fault report`}
          </CustomButton>
        )}
      </CardActions>
    </HomeCard>
  )
}

export { FaultReportList }
